import React from "react";

const PricingPlan = () => (
  <div
    className="w-full text-white text-left md:text-center px-4 md:px-20 lg:px-32 xl:px-[120px] pt-4 pb-8 md:pt-10 md:pb-16"
    style={{ backgroundColor: "#020013" }}
  >
    <p
      className="lowercase md:mx-auto"
      style={{ fontFamily: "Inter, sans-serif", fontWeight: 400, fontSize: "16px", lineHeight: "160%", letterSpacing: "0.25%", color: "#FFFFFF", maxWidth: "1100px" }}
    >
      every order costs time and money. traditional waiters can only take one table at a time — writing, walking, re-entering, and relaying orders to the kitchen. beɘmz replaces that with instant, unlimited chat-based ordering and kitchen relay — at a fraction of the cost.
    </p>
  </div>
);

export default PricingPlan;
